<template>
  <div id="contenedor-agregar-nuevo-status-contrato">
    <v-form ref="agregarEtiqueta" v-model="esFormularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nueva etiqueta
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Nombre"
            v-model="etiqueta.nombre"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <v-row no-gutters>
            <v-col cols="2">
              <v-label>Color</v-label>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                    class="ma-2"
                    size="30"
                    :color="etiqueta.color"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-avatar>
                </template>
                <v-color-picker
                  v-model="etiqueta.color"
                  mode="hexa"
                  hide-canvas
                  hide-inputs
                  hide-mode-switch
                  hide-sliders
                  show-swatches
                  swatches-max-height="250"
                >
                </v-color-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" >
              <v-switch
                v-model="etiqueta.esTextoClaro"
                label="¿Texto Blanco?"
                inset
                style="margin-top: 7px;"
                hide-details
              >
              </v-switch>
            </v-col>
            <v-col cols="6">
              Vista previa:
              <v-chip
                :color="etiqueta.color"
                :text-color="etiqueta.esTextoClaro ? 'white' : 'black'"
                class="ma-2"
              >
              <v-icon left>
                mdi-label
              </v-icon>
                {{ etiqueta.nombre || 'Etiqueta de ejemplo' }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarEtiqueta"
            :disabled="!esFormularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixEtiquetas from './mixEtiquetas';

export default {
  name: 'CatalogosEtiquetas',
  mixins: [mixEtiquetas],
  props: {
    modulo: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      etiqueta: {
        nombre: '',
        modulo: this.modulo || 'CONTRATOS',
        color: '#F44336FF',
        esTextoClaro: false,
      },
      menu: false,
      etiquetasFiltros: {
        modulo: this.modulo,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.etiqueta.color = '#F44336FF';
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarEtiqueta.reset();
      this.etiqueta.esTextoClaro = false;
    },
  },
};
</script>

<style>
</style>
